import { Icon } from "@ospweb/sdk-ui";
import { cn } from "utils";
import { I18nUtil } from "@utils";
import Translations from "@translate/components/Watchlist/ShowAll";

const I18n = I18nUtil.createScoped(Translations);

export const ShowAll = ({ onClick }: { onClick: () => void }) => {
  return (
    <button
      aria-label="Show All"
      data-openreplay-label="Show All Button"
      id="btn-show-all"
      className="flex justify-center items-center px-4 py-2 mx-auto mt-1"
      onClick={onClick}
    >
      <div className="body_s text-content_tertiary">
        {I18n.t("Show all delisted tokens")}
      </div>
      <Icon
        name="chevron-down"
        className={cn("text-content_tertiary")}
        size={20}
      />
    </button>
  );
};
